import {
  BUY_TRANSACTION,
  EXCHANGE_TRANSACTION,
  FundNoteAutoBuy,
  FundNoteAutoRMD,
  SELL_TRANSACTION,
  SystemCode,
  // FundNoteAutoExchange,
} from 'src/settings/settings';
import {
  checkFoundFeaturesByCode,
  updateFundNote,
  // DISABLE_ON_MATCH,
  // isRolloverOrTraditionalIRA,
} from '../shared/shared-fund-notes-utility';

/**
 * Creates function for looking up recurring specific server codes
 * @param {UserFund} fund
 * @param {Number} serviceCode
 * @returns {boolean}
 */
function checkFoundFeaturesByCodeForRecurring(fund, serviceCode) {
  return checkFoundFeaturesByCode(fund, serviceCode, true);
}

export function updateAutoRMDFundNotes(fund, rmds) {
  // if rmd exists and disproportionate disable and show fund note
  const fundRMD = rmds.find(
    (f) => f?.sourceAgreementKey?.agreementID === fund.agreementID
  );

  updateFundNote(
    fund,
    fundRMD && fundRMD?.rmdType?.toUpperCase() === 'DISPROPORTIONATE',
    FundNoteAutoRMD.AUTO_RMD,
    true
  );
}
export function updateAutomaticSellFundNotesForFund(fund, rmds) {
  updateFundNote(
    fund,
    fund.recurringTransactionTypes.indexOf(BUY_TRANSACTION) >= 0 ||
      checkFoundFeaturesByCodeForRecurring(
        fund,
        SystemCode.SYSTEMATIC_PURCHASE_TO_ACCOUNT
      ),
    FundNoteAutoBuy.AUTO_BUY
  );

  updateAutoRMDFundNotes(fund, rmds);

  //Disabled for now due to new buiness rules (May have edited copy later)
  /*updateFundNote(
    fund,
    rmds.length > 0 &&
      fund.agreementType !== 'COLLEGE_SAVINGS' &&
      isRolloverOrTraditionalIRA(fund),
    FundNoteAutoExchange.EXISTING_RMD,
    DISABLE_ON_MATCH
  );*/

  updateFundNote(
    fund,
    fund.recurringTransactionTypes.indexOf(EXCHANGE_TRANSACTION) >= 0 &&
      fund.agreementType !== 'COLLEGE_SAVINGS',
    FundNoteAutoBuy.AUTO_EXCHANGE
  );

  updateFundNote(
    fund,
    fund.recurringTransactionTypes.indexOf(SELL_TRANSACTION) >= 0 &&
      fund.agreementType !== 'COLLEGE_SAVINGS',
    FundNoteAutoBuy.AUTO_SELL
  );
}
